import {Command} from '@application/command/command';
import {CalendarItemGroup} from '@domain/planning/calendar-item-group';
import {PlanningMachineCarpetRun} from '@domain/planning/carpet/planning-machine-carpet-run';
import {ProductionOrderCarpetForPlanningOrder} from '@domain/planning/carpet/production-order-carpet-for-planning-order';
import {PlanningMachineRun} from '@domain/planning/planning-machine-run';
import {PlanningMachineTuftingRun} from '@domain/planning/tufting/planning-machine-tufting-run';
import {ProductionOrderTuftingForPlanningOrder} from '@domain/planning/tufting/production-order-tufting-for-planning-order';
import {PlanningMachineWeavingRun} from '@domain/planning/weaving/planning-machine-weaving-run';
import {ProductionOrderWeavingForPlanningOrder} from '@domain/planning/weaving/production-order-weaving-for-planning-order';
import {find} from 'lodash-es';
import {AddNewPlanningItemCommand} from '../add-new-planning-item/add-new-planning-item-command';
import {AddUnplannedOrderToNewRunParameters} from './add-unplanned-order-to-new-run-parameters';

export class AddUnplannedOrderToNewRunCommand implements Command<AddUnplannedOrderToNewRunParameters, CalendarItemGroup[]> {
  private readonly addNewPlanningItemCommand = new AddNewPlanningItemCommand();

  public execute(commandArgs: AddUnplannedOrderToNewRunParameters): CalendarItemGroup[] {
    const {unplannedPlanningOrder, machine, groupedCalendarItems} = commandArgs;
    let newRun: PlanningMachineRun;
    if (unplannedPlanningOrder.productionOrder instanceof ProductionOrderCarpetForPlanningOrder) {
      newRun = new PlanningMachineCarpetRun(
        null,
        unplannedPlanningOrder.productionOrder.machineQuality,
        unplannedPlanningOrder.productionOrder.creel,
        [unplannedPlanningOrder],
        unplannedPlanningOrder.startDate,
        unplannedPlanningOrder.endDate,
        true
      );
    } else if (unplannedPlanningOrder.productionOrder instanceof ProductionOrderWeavingForPlanningOrder) {
      newRun = new PlanningMachineWeavingRun(
        null,
        unplannedPlanningOrder.productionOrder.weaveProduct,
        [unplannedPlanningOrder],
        unplannedPlanningOrder.startDate,
        unplannedPlanningOrder.endDate,
        true
      );
    } else if (unplannedPlanningOrder.productionOrder instanceof ProductionOrderTuftingForPlanningOrder) {
      newRun = new PlanningMachineTuftingRun(
        null,
        unplannedPlanningOrder.productionOrder.tuftProduct,
        [unplannedPlanningOrder],
        unplannedPlanningOrder.startDate,
        unplannedPlanningOrder.endDate,
        true
      );
    }

    const destinationGroupedCalendarItem = find(groupedCalendarItems, {machineId: machine.id});

    return this.addNewPlanningItemCommand.execute({newPlanningItem: newRun, destinationGroupedCalendarItem, groupedCalendarItems});
  }
}
